// SOURCE OF TRUTH — 3-Day Online Training cohort calendar (start = ISO date of Day 1)
export const LIVE_SESSIONS = [
  { dates: '23 — 25 June 2026', start: '2026-06-23', status: 'full' },
  { dates: '28 — 30 July 2026', start: '2026-07-28', status: 'full' },
  { dates: '22 — 24 September 2026', start: '2026-09-22', status: 'full' },
  { dates: '28 — 30 September 2026', start: '2026-09-28', status: 'full' },
  { dates: '20 — 22 October 2026', start: '2026-10-20', status: 'full' },
  { dates: '27 — 29 October 2026', start: '2026-10-27', status: 'full' },
  { dates: '24 — 26 November 2026', start: '2026-11-24', status: 'last' },
  { dates: '17 — 19 December 2026', start: '2026-12-17', status: 'open' },
  { dates: '14 — 16 January 2027', start: '2027-01-14', status: 'open' },
  { dates: '20 — 22 January 2027', start: '2027-01-20', status: 'open' },
  { dates: '17 — 19 February 2027', start: '2027-02-17', status: 'open' },
];

